<div class="row p-2 mb-3 align-items-center">
  <div class="col-12 col-md-7 text-start">
    <div class="page-title-heading">
      <div class="page-title-icon"><i class="fa-solid fa-comments"></i></div>
      <div>
        Détails de la  requête {{data?.code}}
        <div class="page-title-subheading"><span *ngIf="data?.status==0" class="badge bg-secondary">Nouvelle préoccupation</span> <span *ngIf="data?.status==1" class="badge bg-warning">En attente de traitement</span> <span *ngIf="data?.status==2" class="badge bg-info">En cours de traitement</span> <span *ngIf="data?.status==3" class="badge bg-success">Traité</span></div>
      </div>
    </div>
  </div>
  <div class="col-12 col-md-5 text-end">
    <app-header></app-header>
  </div>
</div>
    <div class="d-flex justify-content-center gap-3 mb-3">
        <button type="button" *ngIf="data?.status==1 && role=='dg'" (click)="open(contentAff)" class="btn btn-primary px-5 rounded-0">Affecter cette préoccupation</button>
        <button type="button" *ngIf="data?.status==2 && role=='dg'" (click)="open(contentAff2)" class="btn btn-primary px-5 rounded-0">Réponde à l'interresé</button>
    </div> 

    <div class="container">
        <div class="row">
            <div class="col-10 mx-auto">
                <div class="card mb-3">
                    <div class="card-header">
                        <h6>Détails de la préoccupation</h6>
                    </div>
                    <div class="card-body">
                        <dl>
                            <dt>Objet</dt>
                            <dd>{{data?.object}}</dd>
                        </dl>
                        <dl>
                            <dt>Message</dt>
                            <dd>
                                <div [innerHTML]="data?.content"></div>
                            </dd>
                        </dl>
                        <dl *ngIf="data?.filename">
                            <dt>PJ</dt>
                            <dd>
                                <button class="btn btn-sm btn-outline-primary" (click)="getFile(data?.code,'',data?.filename)">Ouvrir</button>
                            </dd>
                        </dl>

                        <div *ngIf="data?.status==4" class="container bg-primary text-white">
                            <fieldset>
                                <legend>Réponse de l'administration</legend>
                                    <p>{{data?.response}}</p>
                            </fieldset>

                        </div>
                    </div>
                </div>

                <div class="card" *ngIf="data?.affectation && data?.user_id!=user.id">
                    <div class="container">
                        <div class="row">
                            <div class="col-12 col-md-6">
                                <dl>
                                    <dt>Instruction</dt>
                                    <dd>{{data?.affectation?.instruction}}</dd>
                                </dl>
                               
                            </div>
                            <div class="col-12 col-md-6">
                                <dl>
                                    <dt>Au plus tard le</dt>
                                    <dd>{{data?.affectation?.delay | date:"dd-MM-yyyy"}}</dd>
                                </dl>
                            </div>
                        </div>
                    </div>
                    <div class="card-body" style="height:22rem">
                        <div class="m-1 p-3 rounded  {{r.user?.id == user.id ?'text-end bg-primary text-white':'bg-body-tertiary text-start'}}" *ngFor="let r of data?.affectation.responses">
                            <h6>{{r.user?.name}}</h6>
                            <p>{{r.content}}</p>
                            <span >{{r.created_at | date:"dd-MM-yyyy hh:mm:ss"}}</span>
                        </div>
                    </div>   
                    <div class="card-footer">
                        <form #addForm="ngForm" (ngSubmit)="storeResponse(addForm.value,addForm)">
                        <div class="form-group">
                            <label for="">Réponse</label>
                            <textarea name="content" ngModel class="form-control"></textarea>
                        </div>
                        <div class="text-center">
                            <button type="submit" class="btn btn-outline-dark" [disabled]="addForm.invalid || loading"  >Répondre<app-loading [isVisible]="loading"></app-loading></button>
                          </div>
                      </form>
                    </div>
                </div>

                <div class="card" *ngIf="data?.affectations.length !=0 && data?.user_id!=user.id">
                    <div class="card-body">
                        <div class="accordion" id="accordionExample">
                            <div *ngFor="let aff of data?.affectations; let i=index" class="accordion-item">
                              <h2 class="accordion-header">
                                <button class="accordion-button" type="button" attr.data-bs-toggle="collapse{{i}}" attr.data-bs-target="#collapseOne{{i}}" aria-expanded="true" attr.aria-controls="collapseOne{{i}}">
                                  {{aff.user?.name}} ({{aff.user?.email}})
                                </button>
                              </h2>
                              <div id="collapseOne{{i}}" class="accordion-collapse collapse {{i==0 ? 'show':''}}" data-bs-parent="#accordionExample">
                                <div class="accordion-body">
                                    <div class="m-1 p-3 rounded  {{r.user?.id == user.id ?'text-end bg-primary text-white':'bg-body-tertiary text-start'}}" *ngFor="let r of aff.responses">
                                        <h6>{{r.user?.name}}</h6>
                                        <p>{{r.content}}</p>
                                        <span >{{r.created_at | date:"dd-MM-yyyy hh:mm:ss"}}</span>
                                    </div>

                                    <form #addForm="ngForm" (ngSubmit)="storeResponse(addForm.value,addForm,aff.id)">
                                        <div class="form-group">
                                            <label for="">Réponse</label>
                                            <textarea name="content" ngModel class="form-control"></textarea>
                                        </div>
                                        <div class="text-center">
                                            <button type="submit" class="btn btn-outline-dark" [disabled]="addForm.invalid || loading"  >Répondre<app-loading [isVisible]="loading"></app-loading></button>
                                          </div>
                                      </form>
                                </div>
                              </div>
                            </div>
                      
                          </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

<ng-template #contentPDF let-offcanvas>
	<div class="offcanvas-header">
    
		<h4 class="offcanvas-title">Visualiseur de fichier</h4>
		<button id="closePDFBtn" type="button" class="btn-close" aria-label="Close" (click)="offcanvas.dismiss('Cross click')"></button>
	</div>
	<div class="offcanvas-body">
        <ngx-extended-pdf-viewer [src]="pdfSrc"
        style="width: 100%; height: 100%"
        ></ngx-extended-pdf-viewer>
	</div>
</ng-template>

<ng-template #contentAff let-c="close" let-d="dismiss">
    <form #addForm="ngForm" (ngSubmit)="store(addForm.value)">
    <div class="modal-header">
      <h6 class="modal-title" id="modal-basic-title">Affectation</h6>
      <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
    </div>
    <div class="modal-body" >
        <div class="row mb-3" >
      
            <div class=" form-goup col-12 mb-3">
                <label for="">Choisir un agent traitant<span class="text-danger ml-2">(*)</span></label>
                <select class="form-control" name="down" ngModel>
                    <option *ngFor="let ua of uas" [value]="ua.id">{{ua.name}} ({{ua.email}})</option>
                </select>
            </div>

                <div class="col-12 mb-3">
                    <label for="">Délai <span class="text-danger ml-2">(*)</span></label>
                    <input type="datetime-local" class="form-control" name="delay" ngModel>
                </div>
                <div class="col-12 mb-3">
                    <label for="">Instruction<span class="text-danger ml-2">(*)</span></label>
                    <textarea class="form-control" class="form-control" name="instruction" ngModel></textarea>
                </div>
        </div>
       
    </div>
    <div class="modal-footer">
      <button type="submit" class="btn btn-outline-dark" [disabled]="addForm.invalid || loading"  >Affecter<app-loading [isVisible]="loading"></app-loading></button>
    </div>
</form>
  </ng-template>
<ng-template #contentAff2 let-c="close" let-d="dismiss">
    <form #addForm="ngForm" (ngSubmit)="finished(addForm.value)">
    <div class="modal-header">
      <h6 class="modal-title" id="modal-basic-title">Réponde à l'interessé</h6>
      <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
    </div>
    <div class="modal-body" >
        <div class="row mb-3" >
   
                <div class="col-12 mb-3">
                    <label for="">Message<span class="text-danger ml-2">(*)</span></label>
                    <textarea class="form-control" class="form-control" name="response" ngModel></textarea>
                </div>
                <div class=" form-group col-12 mb-3">
                    <label for="">PJ</label>
                    <input type="file" class="form-control" ngModel (change)="upload($event)" >
                </div>
        </div>
       
    </div>
    <div class="modal-footer">
      <button type="submit" class="btn btn-outline-dark" [disabled]="addForm.invalid || loading"  >Répondre<app-loading [isVisible]="loading"></app-loading></button>
    </div>
</form>
  </ng-template>